import { UserSearchPreferences } from "./user-search-preferences";

export class UserSearchPreferencesFactory {
  static create(payload: any): UserSearchPreferences {
    const userSearchPreferences = new UserSearchPreferences();
    userSearchPreferences.setFilterText(payload ? payload.filterText : "");
    userSearchPreferences.setTransactionalManagementAutoPageRefresh(payload && payload.transactionalManagementAutoPageRefresh);
    return userSearchPreferences;
  }
}
